import { render, staticRenderFns } from "./LunchInformationBox.vue?vue&type=template&id=b9e72b1a&scoped=true&"
import script from "./LunchInformationBox.vue?vue&type=script&lang=ts&"
export * from "./LunchInformationBox.vue?vue&type=script&lang=ts&"
import style0 from "./LunchInformationBox.vue?vue&type=style&index=0&id=b9e72b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e72b1a",
  null
  
)

export default component.exports